import React from 'react';
import { kebabCase } from 'lodash';
import Collapse from '@mui/material/Collapse';
import { useTheme } from '../../styles';
import { OpenInNew, ExpandLess, ExpandMore } from '../../Icons/Core';
import Icon from '../../Icon';
import Grid from '../../Grid';
import List, { ListItem, ListItemIcon, ListItemButton } from '../../List';
import Typography from '../../Typography';
import { ProductName } from './types';
import { productCategoryIconMap } from './constants';
import { FaviconEts, FaviconEmail } from '../../Logos/Favicons';
const ProductSwitcher = (props) => {
    const { subscriptionGroups, standaloneProductsString = 'Standalone Products', currentProductId, onClick, 
    /* To be removed in the future */
    ets, incidentResponse, impersonationProtection, optionalPath } = props;
    /* To be removed in the future */
    const { incidentResponsePath, impersonationProtectionPath } = optionalPath || {};
    const allowOptionalPathApps = [ProductName.IMPERSONATION_PROTECTION, ProductName.INCIDENT_RESPONSE];
    const theme = useTheme();
    const [expandedSections, setExpandedSections] = React.useState({});
    const handleToggle = (groupId) => {
        setExpandedSections(prev => (Object.assign(Object.assign({}, prev), { [groupId]: !prev[groupId] })));
    };
    // Component for hardcoded products defined inside main component
    // so it has access to ets, incidentResponse, and impersonationProtection
    // to be removed in the future
    const HardcodedProductItem = ({ item, index }) => (React.createElement(ListItem, { key: `${item === null || item === void 0 ? void 0 : item.appName}-${index}` },
        React.createElement(Grid, { container: true, display: "flex", alignItems: "center" },
            React.createElement(Grid, { item: true, component: "a", key: `${item.appName}-${index}`, href: item.url, target: item === incidentResponse || item === impersonationProtection ? '_blank' : '_self', style: { textDecoration: 'none', color: 'inherit' }, sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: theme.palette.space.component.default,
                    flex: 1,
                    overflow: 'hidden'
                } },
                React.createElement(ListItemIcon, { sx: { minWidth: '0px' } }, item === ets ? (React.createElement(FaviconEts, { viewBox: "0 0 56 56", height: theme.palette.icon.size.medium, width: theme.palette.icon.size.medium })) : (React.createElement(FaviconEmail, { viewBox: "0 0 56 56", height: theme.palette.icon.size.medium, width: theme.palette.icon.size.medium }))),
                React.createElement(Typography, { variant: "body1", noWrap: true, sx: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        flex: 1
                    } }, item.appName),
                item === incidentResponse || item === impersonationProtection ? (React.createElement(Grid, { item: true, display: "flex", alignContent: "center" },
                    React.createElement(Icon, { bdsSize: "medium", bdsIcon: OpenInNew }))) : null))));
    return (React.createElement("div", { style: { width: '100%' } },
        (ets || incidentResponse || impersonationProtection) && (React.createElement(List, null, [ets, incidentResponse, impersonationProtection].map((item, index) => item && React.createElement(HardcodedProductItem, { key: index, item: item, index: index })))),
        subscriptionGroups.map((subscriptionGroup) => {
            var _a;
            const isExpanded = (_a = expandedSections[subscriptionGroup.id]) !== null && _a !== void 0 ? _a : true;
            return (React.createElement("div", { key: subscriptionGroup.id },
                React.createElement(ListItemButton, { onClick: () => handleToggle(subscriptionGroup.id), style: {
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: 0
                    } },
                    subscriptionGroup.isBundle ? (React.createElement(Typography, { variant: "body1Bold" }, subscriptionGroup.bundle.name)) : subscriptionGroup.id === 'STANDALONE_PRODUCTS' ? (React.createElement(Typography, { variant: "body1Bold" }, standaloneProductsString)) : (''),
                    (subscriptionGroup.isBundle || subscriptionGroup.id === 'STANDALONE_PRODUCTS') &&
                        (isExpanded ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null))),
                React.createElement(Collapse, { in: isExpanded, timeout: "auto", unmountOnExit: true },
                    React.createElement(List, null, subscriptionGroup.subscriptions.map((subscription) => {
                        const openInNew = subscription.product.uxOptions.openInNewTab;
                        const LogomarkIcon = productCategoryIconMap[subscription.product.category] || productCategoryIconMap.MISCELLANEOUS;
                        const kebabCaseName = kebabCase(subscription.product.name);
                        // Create a distinct tracking function with product data
                        const handleClick = () => {
                            if (onClick) {
                                onClick(subscription); // Only pass subscription, no event
                            }
                        };
                        return (React.createElement(ListItem, { key: subscription.product.id, component: "div", selected: subscription.product.id === currentProductId },
                            React.createElement(Grid, { container: true, display: "flex", alignItems: "center", sx: { gap: theme.palette.space.component.default } },
                                React.createElement(Grid, { component: "a", "data-testid": `product-switcher-item-${kebabCaseName}`, item: true, flexDirection: "row", href: allowOptionalPathApps.includes(subscription.product.name) && !!optionalPath
                                        ? `${subscription.product.appUrls.main}/${subscription.product.name === ProductName.IMPERSONATION_PROTECTION
                                            ? impersonationProtectionPath
                                            : incidentResponsePath}`
                                        : subscription.product.appUrls.main, target: openInNew ? '_blank' : '_self', onClick: handleClick, sx: {
                                        textDecoration: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        flex: 1,
                                        overflow: 'hidden',
                                        justifyContent: 'space-between'
                                    } },
                                    React.createElement(Grid, { item: true, sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: theme.palette.space.component.default,
                                            flex: 1,
                                            overflow: 'hidden'
                                        } },
                                        subscription.product.category && (React.createElement(ListItemIcon, { sx: { minWidth: '0px' } },
                                            React.createElement(LogomarkIcon, { viewBox: "0 0 56 56", height: theme.palette.icon.size.medium, width: theme.palette.icon.size.medium }))),
                                        React.createElement(Typography, { variant: "body1", noWrap: true, sx: {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                flex: 1
                                            } }, subscription.product.name)),
                                    openInNew && (React.createElement(Grid, { item: true, display: "flex", alignContent: "center" },
                                        React.createElement(Icon, { bdsSize: "medium", bdsIcon: OpenInNew })))))));
                    })))));
        })));
};
export default ProductSwitcher;
//# sourceMappingURL=ProductSwitcher.js.map